export const documentDownloadsPath = (slug: string) =>
  `/${slug}/document_downloads`;
